import { render, staticRenderFns } from "./TokensCard.vue?vue&type=template&id=7731b476&"
import script from "./TokensCard.vue?vue&type=script&lang=js&"
export * from "./TokensCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports